import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/__main/")({
  beforeLoad: () => {
    throw redirect({ to: "/de" as any });
  },
  component: () => null,
});
